<template>
  <div class="">
    <el-dialog
      title="ORDER CANCEL"
      :before-close="handleClose"
      :visible.sync="orderCancelModal"
      custom-class="text-white font-semibold text-xl"
      width="30%"
      ><div class="bg-white">
        <!-- <div class="flex justify-between bg-primary py-3 px-5">
          <h1 class="text-white font-semibold text-xl">ORDER CANCEL</h1>

          <XIcon
            class="text-white cursor-pointer"
            @click.prevent="handleClose()"
          />
        </div> -->
        <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="p-6">
            <div>
              <div>
                <div class="mb-5">
                  <label class="font-semibold fsize16"
                    >Order Cancel Message</label
                  ><el-form-item prop="cancelMsg">
                    <el-input
                      type="textarea"
                      placeholder="Enter Order Cancel Message"
                      v-model="ruleForm.cancelMsg"
                      class=""
                    ></el-input
                  ></el-form-item>
                </div>
                <div class="">
                  <div class="flex justify-center mt-2">
                    <div>
                      <el-button
                        class="core-btn core-filledbtn w-full md-rounded-6px mb-4 bg-primary text-white font-medium text-sm"
                        @click.prevent="onValidateSubmit('ruleForm')"
                      >
                        SAVE
                      </el-button>
                    </div>
                    <!-- <div>
                      <el-button
                        class="core-btn core-filledbtn text-white w-full md-rounded-6px mb-4 ml-4 font-medium text-sm"
                        @click.prevent="handleClose()"
                      >
                        CLOSE
                      </el-button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div></el-form
        >
      </div>
    </el-dialog>
    <el-select
      placeholder="Select"
      v-model="orderStatus"
      v-if="orderStatus === 'Delivered' || orderStatus === 'Cancelled'"
      disabled
    >
    </el-select>
    <el-select
      placeholder="Select"
      v-model="orderStatus"
      v-else
      v-on:change="dropdownEvent()"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item"
        :disabled="handleDisabled(item, orderStatus)"
        v-bind:value="item"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { XIcon } from "vue-feather-icons";
// import AddDispatcher from "./dispatcher/AddDispatcher.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  props: {
    itemData: {
      type: Object,
      required: true,
    },
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    // AddDispatcher,
    XIcon,
  },
  data() {
    return {
      orderStatus: null,
      currentStatus: null,
      selectedData: null,
      options: [
        "Order Received",
        "Confirm Order",
        "Shipped",
        "Out for delivery",
        "Delivered",
        "Cancelled",
      ],
      orderCancelModal: false,
      ruleForm: {
        cancelMsg: "",
      },
      rules: {
        cancelMsg: [
          {
            required: true,
            message: "Message is Required",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    // isActiveLocal: {
    //   get() {
    //     return this.orderCancelModal;
    //   },
    //   async set(val) {
    //     if (!val) {
    //       this.orderCancelModal = false;
    //       this.clearValidateAndClose("ruleForm");
    //     }
    //   },
    // },
    statusIndex() {
      return this.options.indexOf(this.orderStatus);
    },
    ...mapState("admin", ["login"]),
    // ...mapState("admin", {
    //   dispatchState: "dispatchState",
    // }),
    // ...mapState("component", ["dispatcherToggle"]),
    // ...mapState("page", ["PageNumber"]),
  },
  watch: {
    async itemData(val) {
      if (val) {
        this.init();
      }
    },
  },
  // async created() {
  //   await this.$store.dispatch("admin/getDispatches");
  // },
  mounted() {
    this.init();
  },
  methods: {
    getIndex(status) {
      return this.options.indexOf(status);
    },
    handleDisabled(item, status) {
      if (this.statusIndex !== -1) {
        if (this.options.indexOf(item) > this.statusIndex) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    init() {
      this.orderStatus = this.itemData.orderStatus;
      this.currentStatus = this.itemData.orderStatus;
    },
    notifyErrorMessage(error) {
      this.$notify.error({
        message: error,
        position: "bottom-right",
      });
    },
    onValidateSubmit(formName) {
      this.ruleForm.cancelMsg = this.ruleForm.cancelMsg.trim();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.handlSubmit();
        } else {
          return;
          // return this.$notify.error({
          //   message: "Validation missing",
          //   position: "bottom-right",
          // });
        }
      });
    },
    clearValidateAndClose(formName) {
      this.$refs[formName].resetFields();
    },
    async handlSubmit() {
      try {
        await this.handleUpdateOrderStatus(
          this.orderStatus,
          this.ruleForm.cancelMsg
        );
        this.orderCancelModal = false;
        this.ruleForm.cancelMsg = "";
      } catch (e) {
        console.log(e);
        this.orderStatus = this.currentStatus;
        return this.$notify.error({
          message: "Failed to Cancel the Order",
          position: "bottom-right",
        });
      }
    },
    handleClose() {
      this.orderStatus = this.currentStatus;
      this.orderCancelModal = false;
      this.ruleForm.cancelMsg = "";
      // this.clearValidateAndClose();
    },
    async dropdownEvent() {
      if (
        this.getIndex(this.currentStatus) + 1 ===
        this.getIndex(this.orderStatus)
      ) {
        const result = await this.confirmAlert();
        if (result.isConfirmed) {
          // this.currentStatus = this.orderStatus;
          // console.log(this.orderStatus);
          return this.handleUpdateOrderStatus(this.orderStatus);
        } else {
          this.orderStatus = this.currentStatus;
          return this.$notify.error({
            message: "Cancelled Status Update",
            position: "bottom-right",
          });
        }
      }
      if (this.orderStatus === "Cancelled") {
        this.orderCancelModal = true;
        // const result = await this.confirmAlert();
        // if (result.isConfirmed) {
        //   // this.currentStatus = this.orderStatus;
        //   console.log(this.orderStatus);
        //   return this.handleUpdateOrderStatus(this.orderStatus);
        // } else {
        //   this.orderStatus = this.currentStatus;
        //   return this.$notify.error({
        //     message: "Cancelled Status Update",
        //     position: "bottom-right",
        //   });
        // }
      }
      if (this.orderStatus !== "Cancelled") {
        this.orderStatus = this.currentStatus;
        return this.$notify.error({
          message: "Previous Step Missing!",
          position: "bottom-right",
        });
      }
    },
    confirmAlert() {
      return this.$swal({
        title: `Are you sure you want to proceed ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      });
    },
    getOrders() {
      this.$emit("getOrders");
    },
    async handleUpdateOrderStatus(item, msg = "") {
      // const result = await this.confirmAlert();
      // if (result.isConfirmed) {
      const payload = {
        orderId: this.itemData._id,
        orderStatus: item,
        adminId: this.login._id,
        isAdmin: true,
      };
      if (msg) Object.assign(payload, { cancelledReason: msg });
      // console.log(payload);
      // return console.log(this.orderStatus);
      try {
        let data = await this.$store.dispatch("EcomOrder/updateOrder", payload);
        if (data.code === 200) {
          this.getOrders();
          this.currentStatus = this.orderStatus;
          this.ruleForm.cancelMsg = "";
          return this.$notify({
            message: `Status: ${item}`,
            position: "bottom-right",
          });
        }
        this.orderStatus = this.currentStatus;
      } catch (e) {
        this.ruleForm.cancelMsg = "";
        this.orderStatus = this.currentStatus;
        return this.$notify.error({
          message: "Failed to update OrderStatus",
          position: "bottom-right",
        });
      }
      // } else this.orderStatus = this.currentStatus = "Dispatch";
    },
    // data() {
    //   let thiss = this.options.indexOf(this.orderStatus) + 1;
    //   console.log(thiss);
    //   return this.options.slice(thiss, 0);
    // },
  },
};
</script>
